import {defineStore} from "pinia";
export const salidaStore = defineStore("salidaStore", {
    state: () =>
        ({
            loading: false as boolean,
            pagination: {
                per_page: 0,
                current_page: 1,
                last_page: 0,
            },
            nuevoCodigo: '',
            tipoInstalacion: '',
            cantidadValeGasolina: '',
            cantidadVales: '',
                funcionarioAutoriza: '',
            salidas: [],
            salida: [],
            newSalida: [],
            presupuesto: [],
            salidasMaterial: [],
            showDialogSalida: false as boolean,
            valeSalidas: [],
            valeSalida: [],
            prestamosMaterial: [],
            prestamoMaterial: [],
            newPrestamoMaterial: [],
            nuevoCodigoVale: '',
            nuevoCodigoCompraMateriales: '',
            nuevoCodigoPrestamo: '',
            nuevoCodigoValeGasolina: '',
            valeSalidaMaterial: [],
            planchaMaterial: [],
            funcionarios: [],
            medidores: [],
            newValeSalida: [],
                historial: [] as any[],
            funcionario_responsable: [],
            chofer_responsable: [],
            estacionServicio: [],
            movilidades: [],
            centroCostos: [],
            litros: [],
            valeGasolina: [],
            newValeGasolina: [],
                centroCostoFuncionario: ''



        }),
});